import { render, staticRenderFns } from "./category-main.vue?vue&type=template&id=3229ef12"
import script from "./category-main.vue?vue&type=script&lang=js"
export * from "./category-main.vue?vue&type=script&lang=js"
import style0 from "./category-main.vue?vue&type=style&index=0&id=3229ef12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports